import React, { forwardRef, useImperativeHandle, useState } from 'react'

import {
  Botao,
  ModalBase,
  ModalBaseProps,
  ModalRef,
  TextArea
} from 'src/componentes'

import {
  ContadorObservacao,
  ContainerDosBotoes,
  ContainerObservacao,
  CorpoModal
} from './styles'

export const LIMITE_OBSERVACAO = 2000

export interface ModalConfirmacaoSituacaoAlunoRef
  extends Omit<ModalRef, 'abrir'> {
  abrir: (
    onConfirmar: (observacao?: string) => void,
    mensagemOpcional?: string | JSX.Element
  ) => void
}

const ModalConfirmacaoComponent: React.ForwardRefRenderFunction<
  ModalConfirmacaoSituacaoAlunoRef,
  ModalBaseProps
> = ({ backdrop }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [mensagem, definirMensagem] = useState<string | JSX.Element>(null)
  const [observacao, definirObservacao] = useState('')
  const [acaoConfirmar, definirAcaoConfirmar] = useState<
    ((observacao?: string) => void) | null
  >(null)

  const abrir = (
    onConfirmar: (observacao?: string) => void,
    mensagemOpcional?: string | JSX.Element
  ) => {
    definirObservacao('')
    definirMensagem(
      mensagemOpcional ?? 'Tem certeza que deseja confirmar esta ação?'
    )
    definirAcaoConfirmar(() => onConfirmar)
    definirAberta(true)
  }

  const fechar = () => {
    definirAberta(false)
    definirMensagem(null)
    definirObservacao('')
    definirAcaoConfirmar(null)
  }

  useImperativeHandle(ref, () => ({
    abrir,
    fechar
  }))

  return (
    <ModalBase id="modal-confirmacao" backdrop={backdrop} aberta={aberta}>
      <CorpoModal>
        {/* TÍTULO DO MODAL */}
        <h2 style={{ marginBottom: '15px', fontSize: '22px', fontWeight: 600 }}>
          Tem certeza?
        </h2>

        {/* TEXTO DA MENSAGEM */}
        <div
          style={{ padding: '0 20px', fontSize: '16px', textAlign: 'center' }}
        >
          {typeof mensagem === 'string' ? <p>{mensagem}</p> : mensagem}
        </div>

        {/* OBSERVAÇÃO (OPCIONAL) */}
        <ContainerObservacao>
          <TextArea
            id="observacao-situacao-aluno"
            name="observacao"
            label="Motivo / observação (opcional)"
            placeholder="Informe o motivo da alteração, se houver"
            maxLength={LIMITE_OBSERVACAO}
            value={observacao}
            onChange={e => definirObservacao(e.target.value)}
          />
          <ContadorObservacao>
            {observacao.length}/{LIMITE_OBSERVACAO}
          </ContadorObservacao>
        </ContainerObservacao>

        {/* BOTÕES */}
        <ContainerDosBotoes>
          <Botao
            texto="Cancelar"
            tema="Secundario"
            type="button"
            onClick={() => {
              fechar()
            }}
          />
          <Botao
            texto="Confirmar"
            type="button"
            onClick={() => {
              const texto = observacao.trim()
              const confirmar = acaoConfirmar
              fechar()
              confirmar && confirmar(texto || undefined)
            }}
          />
        </ContainerDosBotoes>
      </CorpoModal>
    </ModalBase>
  )
}

export const ModalConfirmacaoSituacaoAluno = forwardRef(
  ModalConfirmacaoComponent
)
